import styles from './Preview.module.scss';
import { useRouter } from 'next/router';
import { useDictionaryContext } from 'application/contexts/DictionaryContext';

export interface PreviewProps {
	url: string;
	children?: React.ReactNode;
}

export const Preview: React.FC<PreviewProps> = ({ children, url }) => {
	const { isPreview } = useRouter();
	const dictionary = useDictionaryContext();

	if (!isPreview) return <>{children}</>;

	return (
		<div className={styles.Preview}>
			<div className={styles.Preview_top}>
				<p>
					{dictionary.getValue('Preview.InPreview')}{' '}
					<a className={styles.Preview_link} href={`/api/exitPreview?slug=${url}`}>
						{dictionary.getValue('Preview.ExitPreview')}
					</a>
				</p>
			</div>
			<div className={styles.Preview_content}>{children}</div>
		</div>
	);
};
